import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  navigation: {
    display: 'flex',
    flexFlow: 'column nowrap',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    background: theme.palette.background.paper,
    width: theme.spacing(50),
    overflowY: 'auto',
    right: 0,
    zIndex: 0,
    height: '100%',
  },

  content: {
    height: `calc(100% - ${theme.spacing(6.5)})`,
  },

  leaderboardContainer: {
    width: '100%',

    [theme.breakpoints.up('lg')]: {
      width: theme.spacing(50),
    },
  },
}));
